import toast from "react-hot-toast"
import {
  ExportLayoutModal,
  FilterSection,
  KpiStrip,
  ReportHero,
  SummaryTable
} from "./components"
import { useItemListSummaryReport } from "./hooks/useItemListSummaryReport"

/**
 * Item List Summary — mengikuti layout referensi HTML (dummy data).
 * Folder: satu tingkat untuk `components/`, `hooks/`, `types/`, `data/`, `utils/`.
 */
export default function ListItemSummary() {
  const report = useItemListSummaryReport()

  return (
    <section className="w-full px-3 py-4 sm:px-4 md:py-6">
      <div className="flex flex-col gap-4 md:gap-5">
      <ReportHero periodLabel={report.periodLabel} />
      <KpiStrip kpi={report.kpi} />
      <FilterSection
        filter={report.filter}
        setFilter={report.setFilter}
        onSearchReport={report.searchReport}
        onResetFilter={report.resetFilter}
        onLatestItems={() =>
          toast("Latest items (dummy)", { icon: "📋", duration: 2500 })
        }
      />
      <SummaryTable
        rows={report.displayRows}
        sort={report.sort}
        onToggleSort={report.toggleSort}
        onExportXls={() => report.openExportModal("xls")}
        onExportPdf={() => report.openExportModal("pdf")}
        onPrint={() => report.openExportModal("print")}
        onViewItem={(row) =>
          toast(`${row.itemCode} — ${row.itemName}`, { duration: 3000 })
        }
      />

      <ExportLayoutModal
        isOpen={report.exportModalOpen}
        onClose={report.closeExportModal}
        printBlocked={report.printBlocked}
        onChooseOrientation={report.executeExport}
      />
      </div>
    </section>
  )
}
